// @flow

import { useSelector } from "react-redux";
import React from "react";

import { MenuItem, Value } from "./styles";
import defaultStatus, * as status from "src/constants/status";
import { getChatroomStatus } from "src/reducers";
import type { RoomId } from "src/types";

type Props = {
  handleStatus: Function,
  roomId?: RoomId,
};

const Group = ({ handleStatus, roomId }: Props) => {
  const pending = defaultStatus[status.PENDING];
  const canceled = defaultStatus[status.CANCELED];
  const statusValue = useSelector(({ app }) =>
    roomId ? getChatroomStatus(app, roomId) : null,
  );

  return (
    <>
      <MenuItem
        tabIndex="0"
        role="button"
        onClick={() => handleStatus(status.PENDING)}
        onKeyPress={() => handleStatus(status.PENDING)}
      >
        <Value color={pending.color} textColor={pending.textColor}>
          {status.ACTIVE}
        </Value>
        <span
          dangerouslySetInnerHTML={{
            __html: `${statusValue === status.PENDING ? "&#10004;" : ""}`,
          }}
        />
      </MenuItem>

      <MenuItem
        tabIndex="0"
        role="button"
        onClick={() => handleStatus(status.CANCELED)}
        onKeyPress={() => handleStatus(status.CANCELED)}
      >
        <Value color={canceled.color} textColor={canceled.textColor}>
          {canceled.text}
        </Value>
        <span
          dangerouslySetInnerHTML={{
            __html: `${statusValue === status.CANCELED ? "&#10004;" : ""}`,
          }}
        />
      </MenuItem>
    </>
  );
};

export default Group;
